import { concatClasses } from "../../../helpers/concatClasses/index.js";
const overlayClasses = ({ dsf_hide_overlay }) => {
  const classes = [
    "fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center mobile:items-end z-modal"
  ];
  if (!dsf_hide_overlay) {
    classes.push("bg-neutral-700/85");
  }
  return concatClasses(classes);
};
export {
  overlayClasses
};
